// TODO: NCTD-1679, remove in favor of connections/src/content/datasource.ts
import { type DatasourceParameters } from '@atlaskit/linking-types';
import { getActiveTraceHttpRequestHeaders } from '@atlaskit/react-ufo/experience-trace-id-context';

import { type DatasourceType } from '@canvas/atlassian-service/datasource';
import { DatasourceService } from '@canvas/atlassian-service/datasource';

export const DATASOURCE_DEFAULT_PAGE_SIZE = 20;
export const DATASOURCE_FETCH_ALL_PAGE_SIZE = 100;
export const DATASOURCE_MAX_TOTAL_COUNT = 200;

export async function getDatasourceResponseByType(
  type: DatasourceType,
  fields: string[],
  parameters: DatasourceParameters,
  pageSize = DATASOURCE_DEFAULT_PAGE_SIZE,
  pageCursor = ''
) {
  const requestParams = {
    fields: fields,
    includeSchema: true,
    parameters,
    pageSize,
    pageCursor
  };

  return await new DatasourceService(type).getData(
    requestParams,
    getActiveTraceHttpRequestHeaders() ?? {}
  );
}
